import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import {
  MdDashboard,
  MdLogout,
  MdPending,
  MdQuestionMark,
  MdVideoCall,
  MdMenu,
} from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import "./AdminSidebar.css";

function AdminSidebar() {
  const navigation = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setData] = useState({});

  const logOut = () => {
    localStorage.removeItem("userData");
    navigation("/login");
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData"));
    if (user) {
      setData(user);
    } else {
      navigation("/login");
    }
  }, []);

  return (
    <Sidebar collapsed={collapsed} className="admin-sidebar">
      {/* Top Logo */}
      <div className="sidebar-top">
        <div className="brand-box">
          {/* <img
            src={require("../../../user.png")}
            alt=""
            className="brand-img"
          /> */}
          {!collapsed && <h3>KinxVerify</h3>}
        </div>

        <button
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          <MdMenu />
        </button>
      </div>

      {/* User Info */}
      <div className="user-panel">
        <img
          src={require("../../../user.png")}
          alt=""
          className="profile-img"
        />
        {!collapsed && (
          <div>
            <h4>{userData.fname}</h4>
            <p>Admin Panel</p>
          </div>
        )}
      </div>

      {/* Menu */}
      <Menu>
        <MenuItem
          icon={<MdDashboard />}
          component={<Link to="/admin/dashboard" />}
        >
          Dashboard
        </MenuItem>

        {userData.lavel == "1" && (
          <>
            <MenuItem
              icon={<FaUsers />}
              component={<Link to="/admin/users" />}
            >
              Users
            </MenuItem>

            <MenuItem
              icon={<MdPending />}
              component={<Link to="/admin/users-pending" />}
            >
              Pending Request
            </MenuItem>

            <MenuItem
              icon={<MdQuestionMark />}
              component={<Link to="/admin/question-master" />}
            >
              Question Master
            </MenuItem>
          </>
        )}

        {userData.lavel == "2" && (
          <MenuItem
            icon={<MdVideoCall />}
            component={<Link to="/admin/video" />}
          >
            Video
          </MenuItem>
        )}

        <MenuItem icon={<MdLogout />} onClick={logOut}>
          Logout
        </MenuItem>
      </Menu>
    </Sidebar>
  );
}

export default AdminSidebar;